import {Component, OnDestroy, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {DxFormComponent} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {RecoveryViewModel} from 'src/app/shared/models/general';
import {FusionAuthService} from '../../../shared/services/fusion-auth';
import {AppInfoService} from '../../../shared/services/general';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'],
})
export class PasswordRecoveryComponent implements OnDestroy {
  @ViewChild(DxFormComponent, {static: true}) public form?: DxFormComponent;
  public formData: RecoveryViewModel = {} as RecoveryViewModel;
  public popupVisible = false;
  private onDestroy$ = new Subject();

  constructor(
    private applicationInfo: AppInfoService,
    private fusionAuth: FusionAuthService,
    private router: Router,
  ) {
  }

  public formSubmitted(event: any): void {
    event.preventDefault();
    if (this.form?.instance.validate().isValid) {
      this.fusionAuth.forgotPassword({
        loginId: this.formData.email,
        sendForgotPasswordEmail: true
      }).pipe(takeUntil(this.onDestroy$)).subscribe(() => {
        this.popupVisible = true;
      }, (error) => {
        if (error.status === 404) {
          notify('There is not any user registered with the introduced email', 'error', 3000);
        } else {
          notify('We are having trouble to succeed your request!', 'error', 3000);
        }
      });
    }
  }

  public async redirectToLogin() {
    this.popupVisible = false;
    await this.router.navigateByUrl('/login');
  }

  public get Logo(): string {
    return this.applicationInfo.logo;
  }

  public get Lab(): string {
    return this.applicationInfo.lab;
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete()
  }
}
